export const I18N = EdspireGrunt_config.i18n || {};
export const CONFIG = EdspireGrunt_config || {};


// WEBPACK FOOTER //
// ./src/globals/config.js